import * as React from 'react';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import './HomePage.css';
import { ImageGallery } from './internalComponents/ImageGallery';
import { ProfilShortcut } from './internalComponents/ProfilShortcut';
import * as ReqType from '../../types/ServerRequests';
import LoginServices from '../../services/LoginServices';
import { UserService } from '../../services/UserService';
import { Link } from 'react-router-dom';
import { MiniSchedule } from './internalComponents/MiniSchedule';

interface State {
    modal: boolean;
    OnclickOnNotification: boolean;
    idImage: string;
    profil?: ReqType.UserView;
}

interface Props {

}

export class HomePage extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {
            modal: false,
            OnclickOnNotification: false,
            idImage: '',
        };
        this.getProfil();
    }

    public getProfil(): void {
        const userId = LoginServices.getInstance().getUserId();
        if (userId !== undefined) {
            UserService.getInstance().getUser(userId).then(
                (response: ReqType.UserView) => {
                    this.setState({ profil: response });
                }
            ).catch(
                (error) => {
                    // alert(error);
                }
            );
        }
    }

    displayListNotification = () => {
        return (
            <ul className="list-group">
                <li className="list-group-item d-flex justify-content-between align-items-center">
                    Dapibus ac facilisis in
                    <span className="badge badge-primary badge-pill">2</span>
                </li>

                <li className="list-group-item d-flex justify-content-between align-items-center">
                    Cras justo odio
                    <span className="badge badge-primary badge-pill">14</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                    Dapibus ac facilisis in
                    <span className="badge badge-primary badge-pill">2</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                    Morbi leo risus
                    <span className="badge badge-primary badge-pill">1</span>
                </li>
            </ul>
        );
    }

    handleChangeClique = () => {
        if (!this.state.OnclickOnNotification) {
            this.setState({ OnclickOnNotification: true });
        } else {
            this.setState({ OnclickOnNotification: false });
        }
    }

    /*dispayNotification = () => {
        var noti: JSX.Element;
        if (!this.state.OnclickOnNotification) {
            noti = (
                <div />
            );
        } else {
            noti = (
                <div>
                    <this.displayListNotification />
                </div>
            );
        }

        return (
            <div>
                <div className="btn-group font-weight-bold" role="group" aria-label="Button group with nested dropdown">

                    <div
                        className="btn-group"
                        role="group"
                    >
                        <button
                            id="btnGroupDrop1"
                            type="button"
                            className="btn btn-secondary font-weight-bold align-content-center dropdown-toggle"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            onClick={this.handleChangeClique}
                        >
                            Notifications <span className="badge badge-light">4</span>
                        </button>
                    </div>

                </div>
                <div>
                    {noti}
                </div>
            </div>
        );
    }*/

    render() {
        var nom;
        const userRole = LoginServices.getInstance().getType();
        if (this.state.profil !== null && this.state.profil !== undefined) {
            if (this.state.profil.userProfile !== null && this.state.profil.userProfile !== undefined) {
                nom = 'Bienvenue ' + this.state.profil.userProfile!.prenom + ' ' + this.state.profil.userProfile!.nom;
            } else {
                nom = 'Bienvenue ' + this.state.profil.username;
            }
        } else {
            nom = '';
        }
        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.ADMIN,
                    UserRole.MEMBER,
                    UserRole.SEMI_PRO,
                    UserRole.USER,
                ]}
            >
                <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                    <h1 className="roboto" style={{ color: 'white', backgroundColor: '#c73471' }}>{nom}</h1>
                    <div className="row" >
                        <div className="text-black-50 col-lg-3 font-weight-bold  space-width">
                            <div className="row rounded space-height" >
                                <Link to="/profile">
                                    <ProfilShortcut />
                                </Link>
                            </div>
                            <div className="row space-height" >
                                <Link to="/medias">
                                    <ImageGallery />
                                </Link>
                            </div>

                        </div>
                        {
                            (userRole === UserRole.USER.toString() ||
                                userRole === UserRole.NOT_LOGED_IN.toString()) ? undefined :
                                (
                                    <div className="col-lg-4 rounded ">
                                        <Link to="/schedule" >
                                            <MiniSchedule title={''} />
                                        </Link>
                                    </div>
                                )
                        }
                    </div>
                </div>
            </PageChorinitia >
        );
    }
} 


// WEBPACK FOOTER //
// ./src/components/HomePage/HomePage.tsx